import constants from '../constants.js';

const AirportsIsEnabled = {
  displayName: 'Enabled',
  dataAt: 'IsEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirportsIsDeleted = {
  displayName: 'Deleted',
  dataAt: 'IsDeleted',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirportsKeepAlive = {
  displayName: 'Keep Alive',
  dataAt: 'KeepAlive',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirportsClassification = {
  displayName: 'Classification',
  dataAt: 'Classification',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsElevationFeet = {
  displayName: 'ElevationFeet',
  dataAt: 'ElevationFeet',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsLongitude = {
  displayName: 'Longitude',
  dataAt: 'Longitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsLatitude = {
  displayName: 'Latitude',
  dataAt: 'Latitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsUtcOffsetHours = {
  displayName: 'UTC Offset Hours',
  dataAt: 'UtcOffsetHours',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsTimeZoneRegionName = {
  displayName: 'Time Zone Region Name',
  dataAt: 'TimeZoneRegionName',
  displayAs: constants.DISPLAY_AS.TIME_ZONE_SELECT,
  selectType: 'single',
  required: true
};

const AirportsCityLongitude = {
  displayName: 'City Longitude',
  dataAt: 'CityLongitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsCityLatitude = {
  displayName: 'City Latitude',
  dataAt: 'CityLatitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsCountryCode = {
  displayName: 'Country Code',
  dataAt: 'CountryCode',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single',
  required: true
};

const AirportsCityCode = {
  displayName: 'City Code',
  dataAt: 'CityCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsCity = {
  displayName: 'City',
  dataAt: 'City',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsIcao = {
  displayName: 'ICAO',
  dataAt: 'Icao',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsIata = {
  displayName: 'IATA',
  dataAt: 'Iata',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsFs = {
  displayName: 'FS',
  dataAt: 'Fs',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportGroupCode = {
  displayName: 'Group Code',
  dataAt: 'AirportGroupCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirportGroupName = {
  displayName: 'Group Name',
  dataAt: 'AirportGroupName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirportsName = {
  displayName: 'Name',
  dataAt: 'Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsId = {
  displayName: 'Id',
  dataAt: 'Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AirportsStateCode = {
  displayName: 'State Code',
  dataAt: 'StateCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsCountryName = {
  displayName: 'Country Name',
  dataAt: 'CountryName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsRegionName = {
  displayName: 'Region Name',
  dataAt: 'RegionName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AirportsNameLabel = {dataAt: 'Name', displayAs: constants.DISPLAY_AS.SUB_HEADING, label: 'Name:'};


const FixedBaseOperatorAirline = {
  displayName: 'Airline',
  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.Airline',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};
const FixedBaseOperatorBuilding = {
  displayName: 'Building',
  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.Building',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};
const FixedBaseOperatorAddress = {
  displayName: 'Address',
  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.Address',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};
const FixedBaseOperatorCity = {
  displayName: 'City',
  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.City',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};
const FixedBaseOperatorState = {
  displayName: 'State',
  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.State',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};
const FixedBaseOperatorCountry = {
  displayName: 'Country',
  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.Country',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};
const FixedBaseOperatorPostalCode = {
  displayName: 'PostalCode',
  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.PostalCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};


const AirportFixedBaseOperatorsItem = {
  displayName: 'Item',
  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FixedBaseOperatorAirline, FixedBaseOperatorBuilding, FixedBaseOperatorAddress,FixedBaseOperatorCity,FixedBaseOperatorState,FixedBaseOperatorCountry,FixedBaseOperatorPostalCode],
  endpoint: 'Airports',
  routeParamId: 'airportsId',
  removeParamId: 'AirportFixedBaseOperatorsItem',
  canDelete: true
};

const AirportFixedBaseOperators = {
  displayName: 'Fixed Base Operators',
  dataAt: 'FixedBaseOperators',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirportFixedBaseOperatorsItem,
  gridCols:
      [{ name: 'Airline', key: 'Airline' },
       { name: 'Building', key: 'Building' },
       { name: 'Address', key: 'Address' }]
};

const AirportsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Airports',
  data:
    {
      Name: '',
      Fs: '',
      Iata: '',
      Icao: '',
      City: '',
      CityCode: '',
      CountryCode: '',
      CountryName: '',
      RegionName: '',
      TimeZoneRegionName: '',
      UtcOffsetHours: '',
      Latitude: '',
      Longitude: '',
      ElevationFeet: '',
      Classification: '',
      AirportGroupName: '',
      AirportGroupCode: ''
    },
  dataAt: '',
  children: [AirportsName, AirportGroupName, AirportGroupCode, AirportsFs, AirportsIata, AirportsIcao, AirportsCity, AirportsCityCode, AirportsCountryCode, AirportsStateCode, AirportsCountryName, AirportsRegionName, AirportsCityLatitude, AirportsCityLongitude, AirportsTimeZoneRegionName, AirportsUtcOffsetHours, AirportsLongitude, AirportsLatitude, AirportsElevationFeet, AirportsClassification],
  endpoint: 'Airports'
};

const AirportsResource = {
  displayName: 'Airports',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  iconClass: 'fa-plane',
  dataAt: '',
  children: [AirportsNameLabel, AirportsId, AirportsName, AirportGroupName, AirportGroupCode, AirportsFs, AirportsIata, AirportsIcao, AirportsCity, AirportsCityCode, AirportsCountryCode, AirportsStateCode, AirportsCountryName, AirportsRegionName, AirportsCityLatitude, AirportsCityLongitude, AirportsTimeZoneRegionName, AirportsUtcOffsetHours, AirportsLatitude, AirportsLongitude, AirportsElevationFeet, AirportsClassification,AirportFixedBaseOperators, AirportsIsDeleted, AirportsIsEnabled, AirportsKeepAlive],
  endpoint: 'Airports',
  routeParamId: 'airportId'
};

// TODO: Remove when entire feature is it's finished
const AirportsList = {
  rootNode: true,
  displayName: 'Airports',
  iconClass: 'fa-plane',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: AirportsResource,
  gridAdd: AirportsAddResource,
  endpoint: 'Airports',
  gridCols: [{name: 'Name', key: 'Name'}, {name: 'City', key: 'City'}, {name: 'Iata', key: 'Iata'}]
};


const PagingAirportsList = {
  rootNode: true,
  displayName: 'Airports',
  iconClass: 'fa-plane',
  displayAs: constants.DISPLAY_AS.PAGING_GRID,
  gridItem: AirportsResource,
  gridAdd: AirportsAddResource,
  canCopyResource: true,
  endpoint: 'Airports',
  gridCols: [{name: 'Name', field: 'Name'}, {name: 'City', field: 'City'}, {name: 'Iata', field: 'Iata'}]
};

export default {
  AirportsList,
  PagingAirportsList,
  AirportsResource,
  AirportsAddResource,
  AirportsNameLabel,
  AirportsId,
  AirportsName,
  AirportGroupName,
  AirportGroupCode,
  AirportsFs,
  AirportsIata,
  AirportsIcao,
  AirportsCity,
  AirportsCityCode,
  AirportsCountryCode,
  AirportsCityLatitude,
  AirportsCityLongitude,
  AirportsStateCode,
  AirportsCountryName,
  AirportsRegionName,
  AirportsTimeZoneRegionName,
  AirportsUtcOffsetHours,
  AirportsLatitude,
  AirportsLongitude,
  AirportsElevationFeet,
  AirportsClassification,
  AirportsIsDeleted,
  AirportsIsEnabled,
  AirportsKeepAlive,
  FixedBaseOperatorAirline, FixedBaseOperatorBuilding, FixedBaseOperatorAddress,FixedBaseOperatorCity,FixedBaseOperatorState,FixedBaseOperatorCountry,FixedBaseOperatorPostalCode,AirportFixedBaseOperators,AirportFixedBaseOperatorsItem
}



// WEBPACK FOOTER //
// ./src/config/fields/airports.js